import React, {Component} from 'react'
import './EventListBody.css'
import ListTable from './ListTable'
import SearchArea from './SearchArea'
import PageFunctionArea from './PageFunctionArea'
import WarningDialog from '../../FunctionArea/WarningDialog'
import {server_ip} from '../../../ipAddress'

class EventListBody extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fullScreen:false,
            listData:[],
            limitNumber:50,
            pageNumber:1,
            totalNumber:0,
            orderType:"ASC",
            orderColumn:"Event_SysID",
            searchWord:[],
            searchColumn:"All",
            showWarningDialog:false,
            deleteRowID:null,
        }
    }

    componentDidMount(){
        //this.checkStoredEventListState()
        this.getAllEvent()
        .then(res=>{
                this.setState({
                listData:res,
                totalNumber:res[0].Event_TotalCount,
            })             
        })
    }

    componentDidUpdate(prevProps, prevState){
        console.log("componentDidUpdate...")
        if(prevState.limitNumber !== this.state.limitNumber || prevState.pageNumber !== this.state.pageNumber || prevState.orderType !== this.state.orderType || prevState.orderColumn !== this.state.orderColumn || prevState.searchWord !== this.state.searchWord || prevState.searchColumn !== this.state.searchColumn)
        {
            console.log("A1")
            if(this.state.searchWord[0] == null)
            {
                console.log("A1-1")
                console.log("searchWord is null")
                this.getAllEvent()
                .then(res=>{
                    this.setState({
                        listData:res,
                        totalNumber:res[0].Event_TotalCount,
                    })             
                })
            }
            else
            {
                console.log("A1-2")
                this.getEventByBasicSearch()
                .then(res=>{
                    this.setState({
                        listData:res,
                        totalNumber:res[0].Event_TotalCount,
                    })             
                })
            }
        }
        else
        {
            console.log("A2")
        }
    }

    componentWillUnmount(){
    }

    getAllEvent = async()=>{
        console.log("proceed getAllEvent...")
        let limitNumber = this.state.limitNumber
        let pageNumber = this.state.pageNumber
        let orderType = this.state.orderType
        let orderColumn = this.state.orderColumn
        let msg = await fetch(server_ip+'/api/event/basicQuery/limit/'+limitNumber+'/pageNumber/'+pageNumber+'/orderColumn/'+orderColumn+'/orderType/'+orderType+'/query/default')

        let output = await msg.json()
        if(msg.status !== 200) throw Error(msg.message)
        //console.log(output)
        return output
    }

    getEventByBasicSearch = async()=>{
        console.log("proceed getEventByBasicSearch...")
        let limitNumber = this.state.limitNumber
        let pageNumber = this.state.pageNumber
        let orderType = this.state.orderType
        let orderColumn = this.state.orderColumn
        let queryWords = encodeURI(JSON.stringify(this.state.searchWord))
        console.log("limitNumber : ",limitNumber)
        console.log("pageNumber : ",pageNumber)
        console.log("orderType : ",orderType)
        console.log("orderColumn : ",orderColumn)
        console.log("queryWords : ",queryWords)
        let msg = await fetch(server_ip+'/api/event/basicQuery/limit/'+limitNumber+'/pageNumber/'+pageNumber+'/orderColumn/'+orderColumn+'/orderType/'+orderType+'/query/'+queryWords)

        let output = await msg.json()
        if(msg.status !== 200) throw Error(msg.message)
        //console.log(output)
        return output
    }

    deleteRow = (msg)=>{
        this.setState({
            showWarningDialog:true,
            deleteRowID:msg
        })
    }

    confirmDeleteRow = async()=>{
        let output = await fetch(server_ip+'/api/event/delete/'+this.state.deleteRowID, {
            method:"put"
        })

        if(output.statusText === "OK")
        {
            this.getAllEvent()
            .then(res=>{
                this.setState({
                    listData:res,
                    showWarningDialog:false,
                    totalNumber:res[0].Event_TotalCount,
                    deleteRowID:null
                })             
            })
        }
    }

    cancelDeleteRow =()=>{
        this.setState({
            showWarningDialog:false,
            deleteRowID:null
        })
    }

    getOrderStatus=(msg)=>{
        console.log("EventListBody getOrderStatus")
        console.log(msg)
       
        this.setState({
            orderColumn:msg.orderColumn,
            orderType:msg.orderType
        })
    }

    getSearchInfo=(msg)=>{
        console.log("getSearchInfo...")
        console.log(msg)
        if(this.state.searchWord !== msg)
        {
            this.setState({
                searchWord:msg
            })
        }        
    }

    getPageLimitInfo=(msg)=>{
        if(this.state.limitNumber !== msg)
        {
            this.setState({
                limitNumber:msg
            })
        }
    }

    getPageNumberInfo=(msg)=>{
        if(this.state.pageNumber !== msg)
        {
            this.setState({
                pageNumber:msg
            })
        }
    }

    getSelectedEvent=(msg)=>{
        this.props.getSelectedEvent(msg)
    }

    divKeyDown=(e)=>{
        console.log("divKeyDown")
        if(e.ctrlKey === true && e.key === 'q')
        {
            console.log("ctrl key and f key been pressed")
            this.setState(prevState=>({
                fullScreen:!prevState.fullScreen
            }))
        }
    }

    fullScreenBoxOnClick = (e) => {
        e.stopPropagation()
        this.setState(prevState=>({
            fullScreen:!prevState.fullScreen
        }))
    }

    divOnClick=()=>{
        console.log('divOnClick')
    }

    render(){
        console.log("render...")

        //let text = this.state.listData[0]?this.state.listData[0].Event_Title:"Not Ready"

        let parentFullScreen = {
            all:'unset',
            position:'relative',
        }

        let parentNotFullScreen = {
            position:'relative',
        }

        let childFullScreen = {
            width:'100vw',
            height:'100vh',
            position:'fixed',
            left:'0',
            top:'0',
            zIndex:'2000',
            backgroundColor:'white'    
        }

        let childNotFullScreen = {
            backgroundColor:'white'
        }

        let fullScreenSymbol = "☐"
        let notFullScreenSymbol = "_"

        


        return(
            <div style={this.state.fullScreen? parentFullScreen:parentNotFullScreen} onKeyDown={this.divKeyDown} onClick={this.divOnClick} tabIndex='0'>
                <div style={this.state.fullScreen? childFullScreen:childNotFullScreen}> 
                    <WarningDialog from={"EventListBody"} showWarningDialog={this.state.showWarningDialog} confirm={this.confirmDeleteRow} cancel={this.cancelDeleteRow}/>
                    <div className ={"rightTopBoxArea"}>
                        <div className = {"rightTopBox"} onClick={this.fullScreenBoxOnClick}>{this.state.fullScreen? notFullScreenSymbol:fullScreenSymbol}</div>
                    </div>
                    <div>   
                        <SearchArea getSearchInfo={this.getSearchInfo}/>
                        <PageFunctionArea getPageLimitInfo={this.getPageLimitInfo} getPageNumberInfo={this.getPageNumberInfo} storedLimitNumber={this.state.limitNumber} storedPageNumber={this.state.pageNumber} storedTotalNumber={this.state.totalNumber}>
                            <ListTable fullScreen={this.state.fullScreen} listData={this.state.listData} getOrderStatus={this.getOrderStatus} storedOrderColumn={this.state.orderColumn} storedOrderType={this.state.orderType} getSelectedEvent={this.getSelectedEvent} deleteRow={this.deleteRow}/>
                        </PageFunctionArea>
                    </div>
                </div>
            </div>
        )
    }
}

export default EventListBody